<template>
  <div class="my-countdown">
    <ul class="m-countdown">
      <li class="m-countdown-item" v-if="isDayShow">{{ days }}</li>
      <li class="m-countdown-item">{{ hours }}</li>
      <li class="m-countdown-item">{{ minutes }}</li>
      <li class="m-countdown-item">{{ seconds }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MyCountdown",
  data() {
    return {
      days: "00",
      hours: "00",
      minutes: "00",
      seconds: "00"
    };
  },
  props: {
    timestamp: Number,
    isDayShow: false
  },
  methods: {
    timeOver() {
      const { timestamp } = this;
      let timeSeconds = timestamp;
      this.timer = setInterval(res => {
        if (timeSeconds <= 0) {
          this.days = "00";
          this.hours = "00";
          this.minutes = "00";
          this.seconds = "00";
        } else {
          timeSeconds--;
          let day = parseInt(timeSeconds / 60 / 60 / 24);
          let hour = parseInt((timeSeconds - day * 24 * 60 * 60) / 60 / 60);
          let minute = parseInt(
            (timeSeconds - day * 24 * 60 * 60 - hour * 60 * 60) / 60
          );
          let second = parseInt(
            timeSeconds - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
          );
          this.days = hour < 10 ? "0" + hour : day;
          this.hours = hour < 10 ? "0" + hour : hour;
          this.minutes = minute < 10 ? "0" + minute : minute;
          this.seconds = second < 10 ? "0" + second : second;
        }
      }, 1000);
    }
  },
  mounted() {
    this.timeOver();
  }
};
</script>

<style>
.m-countdown {
  display: flex;
}
.m-countdown-item {
  color: #fff;
  background: #000;
  padding: 0.1rem;
  border-radius: 0.1rem;
  margin-left: 0.2rem;
  position: relative;
  min-width: 0.26rem;
  text-align: center;
}
.m-countdown-item::after {
  content: ":";
  position: absolute;
  color: #000;
  left: -0.15rem;
  font-weight: bold;
}
.m-countdown-item:first-child {
  margin-left: 0;
}
.m-countdown-item:first-child::after {
  content: "";
}
</style>


// WEBPACK FOOTER //
// src/pages/mobile/components/MyCountdown/index.vue